<template>
  <AppDialog :is-open="isDialogOpened"
             :ok-loading="deleteSectionPending"
             :ok-disabled="deleteSectionPending"
             :cancel-disabled="deleteSectionPending"
             :ok-text="$t('project.checklist.dialogs.ChecklistDeleteSectionDialog.confirmLabel')"
             data-locator="checklist-section-delete-dialog"
             @cancel="closeDialog"
             @ok="onConfirmDeleteSection"
  >
    <template #title>
      {{ $t('project.checklist.dialogs.ChecklistDeleteSectionDialog.title') }}
    </template>
    <template #body>
      <div v-if="isDeletionValidationEnabled">
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteSectionDialog.deletionValidationText.sentence1') }}</p>
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteSectionDialog.deletionValidationText.sentence2') }}</p>
      </div>
      <template v-else>
        <i18n-t keypath="project.checklist.dialogs.ChecklistDeleteSectionDialog.text" tag="p" scope="global">
          <template #sectionTitle>
            <span class="text--bold">{{ section.title }}</span>
          </template>
        </i18n-t>
      </template>
    </template>
  </AppDialog>
</template>

<script>
import { mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'ChecklistDeleteSectionDialog',
  components: { AppDialog },
  emits: ['confirm'],
  mixins: [dialogMixin],
  props: {
    isDeletionValidationEnabled: {
      type: Boolean,
    },
    section: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('checklist', ['deleteSectionPending']),
  },
  methods: {
    onConfirmDeleteSection() {
      this.$emit('confirm')
    },
  },
}
</script>
